'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _Speaker = require('../Speaker');

var _Speaker2 = _interopRequireDefault(_Speaker);

var _TranscriptSegment = require('../TranscriptSegment');

var _TranscriptSegment2 = _interopRequireDefault(_TranscriptSegment);

var _TranscriptWord = require('../TranscriptWord');

var _TranscriptWord2 = _interopRequireDefault(_TranscriptWord);

var _Transcript = require('../Transcript');

var _Transcript2 = _interopRequireDefault(_Transcript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KaldiAdapter = function () {
  function KaldiAdapter() {
    _classCallCheck(this, KaldiAdapter);
  }

  _createClass(KaldiAdapter, null, [{
    key: 'parse',
    value: function parse(transcriptJson, segmentsJson) {
      var speakerIdMap = {};
      var speakers = [];

      var words = transcriptJson.words.reduce(function (currentWords, word) {
        var segmentIndex = segmentsJson.segments.findIndex(function (segment) {
          return word.start >= segment.start && word.end < segment.start + segment.duration;
        });

        if (segmentIndex === -1) {
          if (currentWords[currentWords.length - 1]) {
            segmentIndex = currentWords[currentWords.length - 1].segmentIndex;
          } else {
            segmentIndex = 0;
          }
        }

        return [].concat(_toConsumableArray(currentWords), [_extends({}, word, { segmentIndex: segmentIndex })]);
      }, []);

      var segments = new _immutable2.default.List(segmentsJson.segments.reduce(function (list, segment, segmentIndex) {
        var segmentWords = words.filter(function (word) {
          return word.segmentIndex === segmentIndex;
        });

        if (segmentWords.length === 0) {
          return list;
        }

        if (!speakerIdMap[segment.speaker['@id']]) {
          speakerIdMap[segment.speaker['@id']] = speakers.push(new _Speaker2.default({ name: null })) - 1;
        }

        return [].concat(_toConsumableArray(list), [new _TranscriptSegment2.default({
          speaker: speakerIdMap[segment.speaker['@id']],
          words: new _immutable2.default.List(segmentWords.map(function (w) {
            return new _TranscriptWord2.default({
              text: w.punct,
              start: w.start,
              end: w.end
            });
          }))
        })]);
      }, []));

      return new _Transcript2.default({ speakers: new _immutable2.default.List(speakers), segments: segments });
    }
  }]);

  return KaldiAdapter;
}();

exports.default = KaldiAdapter;